import React from 'react'
import { useForm } from 'react-hook-form';
import { BiSend } from 'react-icons/bi';
import { IoIosSend } from 'react-icons/io';
import { IoSearchOutline } from 'react-icons/io5';

export const SubscriptionFrom = () => {
    const { register, handleSubmit, reset, watch } = useForm({
        defaultValues: { query: "" },
    });
    const submitHandler = (data) => {
        console.log("Search submit:", data);
      
    };
    return (
        <form
            onSubmit={handleSubmit(submitHandler)}
            name="search"
            className={`flex relative rounded-full w-[95%] md:w-[80%]  lg:w-[40%] h-[45px] overflow-hidden `}
        >
            <input
                {...register("query")}
                placeholder="Nhập email của bạn"
                type="text"
                className="flex-1 h-full outline-none px-4 bg-white  w-[70%] md:w-[70%]"
                
            />

          
            <button
                type="submit"
                className="bg-[--color-button-2] w-[35%] md:w-[30%] h-full rounded-r-full text-sm flex justify-center items-center gap-2 hover:bg-black hover:text-white transition-all duration-300"
            >
                <span className=""><IoIosSend /></span>
                <span className="font-bold">Đăng ký</span>
                
            </button>
        </form>
    )
}
